import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

function isChunkLoadError(err) {
  if (!err) return false;
  const message = err.message || String(err);
  const name = err.name || '';
  return name === 'ChunkLoadError' || /Loading chunk .* failed/i.test(message);
}

function reloadOnStaleChunk() {
  const key = 'chunk_reload_ts';
  const last = Number(sessionStorage.getItem(key) || 0);
  const now = Date.now();
  // After a dev-server restart, cached bundle.js may reference old lazy chunks.
  if (now - last > 8000) {
    sessionStorage.setItem(key, String(now));
    window.location.reload();
    return true;
  }
  return false;
}

window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault();
    reloadOnStaleChunk();
  }
});

window.addEventListener('error', (event) => {
  if (isChunkLoadError(event.error) || /Loading chunk .* failed/i.test(event.message || '')) {
    reloadOnStaleChunk();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
